import DecedentList from '@/pages/decedent-list/DecedentList';

export default DecedentList;
